import { useCallback, useRef } from 'react';

import CustomButton from '../../../common/CustomButton/CustomButton';
import CustomLink from '../../../common/CustomLink/CustomLink';
import { Icon } from '../../../common/Icon/Icon';
import Markdown from '../../../common/Markdown/Markdown';
import NoTagRenderer from '../../../common/NoTagRenderer/NoTagRenderer';
import { slugify } from '../../../core/helpers';
import useModal from '../../../core/hooks/useModal';
import { ILink } from '../../../core/models';
import HubSpotForm from '../../HubSpotForm/HubSpotForm';
import './AudienceItem.css';

export interface IAudienceItem {
  title: string;
  desc?: string;
  cta?: ILink;
  form: {
    portalId?: string;
    formId?: string;
    region?: string;
    id?: string;
    btnLabel?: string;
  };
  slug: string;
}

function AudienceItem({ title, desc, form, slug, cta }: IAudienceItem) {
  const { modal, open, close } = useModal();
  const btnRef = useRef(null);

  const openModal = useCallback(() => {
    if (!btnRef.current) return;
    open(btnRef.current);
  }, [open]);

  return (
    <div className="audience__item" key={title}>
      <div className="audience__item-container flex gap-md">
        <h2 className="audience__item-title h2">
          <Markdown
            components={{
              p: NoTagRenderer,
            }}
          >
            {title}
          </Markdown>
        </h2>
        {!desc ? null : <Markdown className="audience__item-desc markdown">{desc}</Markdown>}
        <div className="audience__item-footer">
          {!form.btnLabel || !form.portalId || !form.formId || !form.region || !form.id ? null : (
            <>
              <CustomButton
                className="audience__item-cta btn"
                type="button"
                onClick={openModal}
                ref={btnRef}
                id={slugify(`${slug}-${form.formId}`)}
              >
                {form.btnLabel}
              </CustomButton>
              {modal({
                children: (
                  <>
                    <CustomButton
                      className="modal__close"
                      onClick={close}
                      type="button"
                      id={slugify(`${slug}-${form.formId}-modal-close`)}
                    >
                      <Icon.Plus className="icon-large" />
                      <span className="sr-only">Close modal</span>
                    </CustomButton>
                    <HubSpotForm
                      portalId={form.portalId}
                      formId={form.formId}
                      region={form.region}
                      id={form.id}
                    />
                  </>
                ),
                keepMounted: true,
              })}
            </>
          )}
          {!cta ? null : <CustomLink link={cta} />}
        </div>
      </div>
    </div>
  );
}

export default AudienceItem;
